import { CostExplorer } from "./CostExplorer";

export const CostPage = () => {

  return (
    <CostExplorer />
  );
};
